var staticStrFirst = 'first'

module.exports = staticStrFirst



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticStrFirst.js
// module id = b/v+
// module chunks = 137